import { action, observable, toJS } from 'mobx';
import { ProjectsStore } from './ProjectsStore';
import { IEditPointsPOST, XYZItem } from 'cd-eft/models/SurveyEngineering/editPoints';
import { IEditBreaklinesPOST } from 'cd-eft/models/SurveyEngineering/editBreaklines';
import { IAddSketchPOST } from 'cd-eft/models/SurveyEngineering/addSketch';
import { IStationOffsetPOST, ICrossSlopeStation, IOffsetStation } from 'cd-eft/models/SurveyEngineering/stationOffset';
import { IAlignmentStation } from 'cd-eft/models/Stores/AlignmentDesignStore';
import { appConfig } from 'cd-eft/config/AppConfig';
import { SketchViewModel, SnappingOptions } from 'cd-eft/utils/esriTypes';
import { ICrossSectionPoint } from './SingleCrossSectionDesignStore';
class SurveyEngineeringProjectsStore extends ProjectsStore {
  constructor(private surveyengineeringstore: any) {
    super(surveyengineeringstore);
  }
}

export class SurveyEngineeringStore {
  constructor(private appStore: any) {
    this.projectsStore = new SurveyEngineeringProjectsStore(this);
    this.init();
  }
  @observable projectsStore: SurveyEngineeringProjectsStore;
  @observable xyzPointsTable: any;
  @observable pointDescriptionFilter: string = 'All';
  @observable crossSlopesTable: any;
  @observable tempXYZPointsTable: any;
  @observable maxId;
  @observable tempMaxId;
  @observable hasGrid!: boolean;
  @observable hasSurvey: boolean = false;
  @observable initXYZPointsLength;
  @observable initTempXYZPointsLength;
  @observable gisModel;
  @observable showMapViewInMain!: boolean;
  @observable deltaX!: number;
  @observable deltaY!: number;
  @observable deltaZ!: number;
  @observable surveySummaryTable: any;
  @observable surveyData: any;
  @observable listOfSOSurveyIds: any;
  @observable surveyAlignments: any;
  // @observable surveySummaryId;
  @observable selectedSurveysInfo: any;
  @observable pointsOnMap: boolean = false;
  @observable surveyFileHeader = ['pointName', 'x', 'y', 'z', 'featureDescription'];
  @observable numHeaderType: any = [];
  @observable numberOfNumericFields: number = 0;
  @observable isHeaderAccepted: boolean = false;
  @observable isImportingNewSurvey: boolean = false;
  @observable importSurveyWindowIsOpen: boolean = false;
  @observable hasFileHeader: boolean = false;
  @observable saveTINSurface: boolean = false;
  @observable isLoading: boolean = false;

  @observable displaySurfaceChecked: boolean = false;
  @observable displayNewSurvey: boolean = false;

  //For DEM Design
  @observable demSurfaceSummaryTable: any;
  @observable demName: any;
  @observable importDEMWindowIsOpen: boolean = false;
  @observable isImportingNewDEM: boolean = false;
  @observable isContourIntervalEdited: boolean = false;
  @observable in_designTypeSelection: string = 'survey'; //['demSurface', 'survey']. used as a flag to track user's decison on Survey or DEM
  @observable upload_dem_file: File | undefined = undefined;
  //Summary
  @observable currentTab: string = 'Survey Summary'; // ['Survey Summary', 'New Survey', 'Point Translation', 'New DEM'];
  @observable currentSubTab: string = 'survey';
  @observable savedDEM: boolean = false;
  @observable savedSurvey: boolean = false;
  @observable currentSurvey: any = {};
  @observable currentDEM: any = { demId: '', demName: '', demType: 10 };
  @observable shapeFilesExportZipUrl: any;

  @observable doRotate: boolean = false;
  @observable surfaceCentroid: any;
  @observable isStatePlane:boolean=false;

  @action changeTab(tab) {
    this.currentSubTab = 'survey';
    this.currentTab = tab;
  }

  @action resetTabs() {
    this.currentTab = 'Survey Summary';
    this.currentSubTab = 'survey';
  }
  @action resetCurrentSurvey() {
    this.currentSurvey = { surveyId: '', surveyName: '', surveyType: 0 };
  }
  @action resetCurrentDEM() {
    this.currentDEM = { demId: '', demName: '', demType: 10 };
  }
  @action resetStationOffsetObject() {
    this.stationOffsetObject = {
      ...this.initialStationOffsetObject,
      offsetStations: [],
      crossSlopeStations: [],
    };
  }
  @action resetSOSurvey() {
    this.resetStationOffsetObject();
    this.resetTabs();
    this.resetCurrentSurvey();
  }

  @action resetXYZSurvey() {
    this.resetTabs();
    this.resetCurrentSurvey();
    this.hasSurvey = false;
    this.isHeaderAccepted = false;
    this.saveTINSurface = false;
    this.selectedSurveysInfo = [];
    this.resetTranslataion();
    this.xyzPointsTable = [];
    this.initXYZPointsLength = 0;
    this.initialXyzPointsTable = [];
    this.hasGrid = false;
    this.pointsOnMap = false;
    this.displayNewSurvey = false;
    this.savedSurvey = false;
  }

  @observable surveyEditables: any[] = [];
  SETMapLayerKeepList: string[] = [];

  /*** Translataion Rotation Section Begin ***/
  selectPointType = '';
  initialXyzPointsTable: any = [];
  @observable translationOptionApplied: number = 0;

  @observable transRefInSelectMode: boolean = false;
  @observable transTargetInSelectMode: boolean = false;
  @observable pivotRefInSelectMode: boolean = false;
  @observable pivotTargetInSelectMode: boolean = false;
  @observable angleRefInSelectMode: boolean = false;
  @observable angleTargetInSelectMode: boolean = false;

  @observable transRefName?: string;
  @observable transRefX: number = 0;
  @observable transRefY: number = 0;
  @observable transRefZ: number = 0;
  @observable transTargetName?: string;
  @observable transTargetX: number = 0;
  @observable transTargetY: number = 0;
  @observable transTargetZ: number = 0;

  @observable pivotRefName?: string;
  @observable pivotRefX: number = 0;
  @observable pivotRefY: number = 0;
  @observable pivotRefZ: number = 0;
  @observable pivotTargetName?: string;
  @observable pivotTargetX: number = 0;
  @observable pivotTargetY: number = 0;
  @observable pivotTargetZ: number = 0;

  @observable pivotDeltaX!: number;
  @observable pivotDeltaY!: number;
  @observable pivotDeltaZ!: number;

  @observable angleRefName?: string;
  @observable angleRefX: number = 0;
  @observable angleRefY: number = 0;
  @observable angleTargetName?: string;
  @observable angleTargetX: number = 0;
  @observable angleTargetY: number = 0;

  @observable rotationAngle: number = 0;
  @observable registrationError?: number;

  @action resetTranslataion() {
    this.translationOptionApplied = 0;
    this.xyzPointsTable = [...this.initialXyzPointsTable];
    this.deltaX = 0;
    this.deltaY = 0;
    this.deltaZ = 0;

    this.transRefName = '';
    this.transRefX = 0;
    this.transRefY = 0;
    this.transRefZ = 0;
    this.transTargetName = '';
    this.transTargetX = 0;
    this.transTargetY = 0;
    this.transTargetZ = 0;

    this.pivotRefName = '';
    this.pivotRefX = 0;
    this.pivotRefY = 0;
    this.pivotRefZ = 0;
    this.pivotTargetName = '';
    this.pivotTargetX = 0;
    this.pivotTargetY = 0;
    this.pivotTargetZ = 0;
    this.pivotDeltaX = 0;
    this.pivotDeltaY = 0;
    this.pivotDeltaZ = 0;
    this.angleRefName = '';
    this.angleRefX = 0;
    this.angleRefY = 0;
    this.angleTargetName = '';
    this.angleTargetX = 0;
    this.angleTargetY = 0;
    this.rotationAngle = 0;
    this.registrationError = 0;

    this.transRefInSelectMode = false;
    this.transTargetInSelectMode = false;
    this.pivotRefInSelectMode = false;
    this.pivotTargetInSelectMode = false;
    this.angleRefInSelectMode = false;
    this.angleTargetInSelectMode = false;
  }
  /*** Translataion Rotation Section End ***/

  @observable xyzArray: XYZItem[] = [];
  breaklinesFromGraphics;
  @observable surveyId;
  @observable editPointsObject!: IEditPointsPOST;
  @observable editBreaklinesObject!: IEditBreaklinesPOST;
  @observable stationOffsetObject!: IStationOffsetPOST;

  @action reset() {
    this.init();
  }

  @action init() {
    this.resetStationOffsetObject();
    this.resetXYZSurvey();

    this.importSurveyWindowIsOpen = false;
    this.displaySurfaceChecked = false;
    this.hasFileHeader = false;
    this.surveyFileHeader = ['pointName', 'x', 'y', 'z', 'featureDescription'];
    this.numHeaderType = [];
    this.numberOfNumericFields = 0;
    this.crossSlopesTable = [];
    this.maxId = 0;
    this.gisModel = { map: null, mapView: null };
    this.showMapViewInMain = true;
    this.xyzArray = toJS([]);
    this.breaklinesFromGraphics = toJS([]);
    this.surveyId = '';
    this.editPointsObject = {
      surfaceDefId: 0,
      sessionId: 'sessionId',
      surveyId: this.surveyId,
      surveyTypeId: '1',
      surveyCoordinateSystem: appConfig.tempHardCodes.wkid,
      surveyName: 'Test Survey',
      xyzArray: this.xyzArray,
    };
    this.editBreaklinesObject = {
      projectId: 'projectguidid',
      sessionId: 'sessionid',
      surveyId: this.surveyId,
      featureTypeId: '2',
      surveyCoordinateSystem: appConfig.tempHardCodes.wkid,
      breaklineArray: [],
    };

    // this.surveySummaryId = 0;
    this.in_designTypeSelection = 'survey';
    this.savedDEM = false;
    this.savedSurvey = false;
    this.surveySummaryTable = [];
    this.surveyData = [];
    this.listOfSOSurveyIds = [];
    this.surveyAlignments = [];

    //for DEM Surfaces Table
    this.demSurfaceSummaryTable = [];
    this.upload_dem_file = undefined;
    this.isStatePlane = false;
  }

  snappingOptions: SnappingOptions | undefined;
  refSnappingOptions: SnappingOptions | undefined;
  targetSnappingOptions: SnappingOptions | undefined;
  transSketchVM: SketchViewModel | undefined;
  rotateSketchVM: SketchViewModel | undefined;
  resetTransformation() {
    if (this.refSnappingOptions) {
      this.refSnappingOptions = undefined;
    }
    this.refSnappingOptions = new SnappingOptions({
      distance: 21,
      enabled: true,
      featureSources: [],
    });
    if (this.targetSnappingOptions) {
      this.targetSnappingOptions = undefined;
    }
    this.targetSnappingOptions = new SnappingOptions({
      distance: 21,
      enabled: true,
      featureSources: [],
    });

    if (this.transSketchVM) {
      this.transSketchVM.destroy();
      this.transSketchVM = undefined;
    }

    if (this.rotateSketchVM) {
      this.rotateSketchVM.destroy();
      this.rotateSketchVM = undefined;
    }
  }
  initValuesTransformation() {
    this[`${this.selectPointType}Name`] = '';
    this[`${this.selectPointType}X`] = 0;
    this[`${this.selectPointType}Y`] = 0;

    this[`${this.selectPointType.replace('Ref', 'Target')}Name`] = '';
    this[`${this.selectPointType.replace('Ref', 'Target')}X`] = 0;
    this[`${this.selectPointType.replace('Ref', 'Target')}Y`] = 0;

    if (this.selectPointType.startsWith('pivot') || this.selectPointType.startsWith('trans')) {
      this[`${this.selectPointType}Z`] = 0;
      this[`${this.selectPointType.replace('Ref', 'Target')}Z`] = 0;
    }
  }

  addSketch: IAddSketchPOST = {
    sessionId: '',
    surfaceDefId: 1,
    designElementTypeId: 1,
    designElementName: 'drawing',
    json: [],
  };

  initialStationOffsetObject: IStationOffsetPOST = {
    surfaceDefId: 4, // Hardcoded initially
    surfaceName: '',
    surveyId: '',
    surveyName: '',
    surveyCoordinateSystem: appConfig.tempHardCodes.wkid,
    alignmentName: '',
    alignmentEntryMethod: 'Coordinates', // 'AngleDistance'
    alignmentAutoGrow: 'true',
    alignmentIncreasing: 'true',
    alignmentAutoCreated: 0,
    beginningX: 2197196.1280505468,
    beginningY: 15002028.114885008,
    alignmentApplyCurves: 'false',
    alignmentStations: [],
  };

  initialOffsetStation: IOffsetStation = {
    alignmentId: 0,
    alignmentName: 'Hardcoded_alignmentName_Centerline',
    stationStep: 50,
    entryMode: 'ELEVATION',
    stationDistance: 0,
    offsetType: 'TYPE_ELEVATION',
    tangentAzimuth: 0,
    hiElevation: 0,
    x: 2197196.1280505468,
    y: 15002028.114885008,
    editingStatus: 'add',
    offsets: [
      {
        offsetDistance: -50,
        z: 0.0,
        editingStatus: 'add',
      },
      {
        offsetDistance: 0,
        z: 0.0,
        editingStatus: 'add',
      },
      {
        offsetDistance: 50,
        z: 0.0,
        editingStatus: 'add',
      },
    ],
  };

  initialCrossSlopeStation: ICrossSlopeStation = {
    alignmentId: 0,
    alignmentName: 'Hardcoded_alignmentName_Centerline',
    crossSlopeId: 0,
    entryMode: 'PERCENTSLOPE',
    uphillsTo: 'LEFT',
    offsetType: 'TYPE_ELEVATION',
    slopeWidth: 30,
    stationStep: 50,
    stationDistance: 0.0,
    singleShotOffset: 20,
    hiElevation: 0.0,
    editingStatus: 'add',
    crossSlopeStationOffsets: [
      {
        crossSlopeStationOffset: 0,
        z: 0.0,
        crossSlopeStationSlope: 0.0,
        editingStatus: 'add',
      },
    ],
  };

  initialAlignmentStation: IAlignmentStation = {
    angleType: 0,
    angle: 0.0,
    curveType: 0,
    curveValue: 0.0,
    stationDistance: 0.0,
    distance: 0.0,
    x: 0.0,
    y: 0.0,
    z: 0.0,
    description: 'alignment station',
    editingStatus: 'add',
    stationName: 0,
  };

  initialCrossSectionPoint: ICrossSectionPoint = {
    pointDistance: 0.0,
    distance: 0.0,
    x: 0.0,
    y: 0.0,
    originalElevation: 0.0,
    designElevation: 0.0,
    cutFillHeight: 0.0,
    sectionPoint: 0,
  };
}
